module.exports = "/_next/static/images/img-md-min-6c50fe175046379899e713d514722753.jpg";